import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
      { path: '/', component: require(page+'user-access/login.vue').default, meta:{title:"Ingresar"} },
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"} },

      { path: '/dashboard', component: require(page+'account/dashboard.vue').default, meta:{ title: 'Mi cuenta' },
  			children: [
    			{ path: '/', name: 'accInicioPage', component: require(page+'account/inicio/index.vue').default, meta:{ title: 'Mi cuenta' } },
          { path: 'comunicados', name: 'accComuPage', component: require(page+'account/comunicados/index.vue').default, meta:{ title: 'Comunicados' } },
          { path: 'comunicados/:id', name: 'accComuDetallePage', component: require(page+'account/comunicados/detail.vue').default, meta:{ title: 'Comunicados' } },

          { path: 'mi-perfil/mis-datos', name: 'accPerfilDatosPage', component: require(page+'account/mi-perfil/mis-datos.vue').default, meta:{ title: 'Mis datos' } },
          { path: 'mi-perfil/mi-foto', name: 'accPerfilFotoPage', component: require(page+'account/mi-perfil/mi-foto.vue').default, meta:{ title: 'Mi foto' } },
          { path: 'mi-perfil/mi-contrasena', name: 'accPerfilContrasenaPage', component: require(page+'account/mi-perfil/mi-contrasena.vue').default, meta:{ title: 'Mi contraseña' } },
          { path: 'mi-perfil/historico-puestos', name: 'accPerfilPuestosPage', component: require(page+'account/mi-perfil/historico-puestos.vue').default, meta:{ title: 'Historico de puestos' } },
          { path: 'mi-perfil/informacion-academica', name: 'accPerfilAcademicaPage', component: require(page+'account/mi-perfil/academica.vue').default, meta:{ title: 'Información academica' } },
          { path: 'mi-perfil/familia', name: 'accPerfilFamilyPage', component: require(page+'account/mi-perfil/familia.vue').default, meta:{ title: 'Familia' } },

          { path: 'plan-de-carrera', name: 'accPerfilCarreraPage', component: require(page+'account/mi-perfil/plandecarrera.vue').default, meta:{ title: 'Plan de carrera' } },
          { path: 'buzon-y-reportes', name: 'accBuzonPage', component: require(page+'account/buzon-reportes/index.vue').default, meta:{ title: 'Ideas gente OZ' } },

          { path: 'beneficios', name: 'accBeneficiosPage', component: require(page+'account/beneficios/index.vue').default, meta:{ title: 'Beneficios de Grupo OZ' } },
          { path: 'beneficios/:id', name: 'accBeneDetallePage', component: require(page+'account/beneficios/detail.vue').default, meta:{ title: 'Beneficios' } },

          { path: 'vacaciones', name: 'accVacacionesPage', component: require(page+'account/vacaciones/index.vue').default, meta:{ title: 'Vacaciones' } },

          { path: 'bolsa-de-trabajo/ofertas', name: 'accBolsaOfertasPage', component: require(page+'account/bolsa-de-trabajo/ofertas.vue').default, meta:{ title: 'Vacantes | Bolsa de trabajo' } },
          { path: 'bolsa-de-trabajo/ofertas/:id', name: 'accBolsaOfeDetallePage', component: require(page+'account/bolsa-de-trabajo/ofertas-detalle.vue').default, meta:{ title: 'Vacantes | Bolsa de trabajo' } },
          { path: 'bolsa-de-trabajo/postulaciones', name: 'accBolsaPostulacionesPage', component: require(page+'account/bolsa-de-trabajo/postulaciones.vue').default, meta:{ title: 'Postulaciones | Bolsa de trabajo' } },
          { path: 'bolsa-de-trabajo/postulaciones/:id', name: 'accBolsaPosDetallePage', component: require(page+'account/bolsa-de-trabajo/postulaciones-detalle.vue').default, meta:{ title: 'Postulaciones | Bolsa de trabajo' } },

          { path: 'permisos-medicos-y-salud', name: 'accPerMedicosPage', component: require(page+'account/permisos-medicos-salud/index.vue').default, meta:{ title: 'Permisos' } },

          { path: 'capacitaciones', name: 'accCapacitacionesPage', component: require(page+'account/capacitaciones/index.vue').default, meta:{ title: 'Capacitaciones' } },
          { path: 'capacitaciones/:id', name: 'accCapDetallePage', component: require(page+'account/capacitaciones/detail.vue').default, meta:{ title: 'Capacitaciones' } },

          { path: 'evaluaciones', name: 'accEvaluacionesPage', component: require(page+'account/evaluaciones/index.vue').default, meta:{ title: 'Evaluaciones' } },
          { path: 'evaluaciones/cualitativa', name: 'accCualitativaPage', component: require(page+'account/evaluaciones/cualitativa.vue').default, meta:{ title: 'Evaluacion Cualitativa' } },
          { path: 'evaluaciones/cuantitativa', name: 'accCuantitativaPage', component: require(page+'account/evaluaciones/cuantitativa.vue').default, meta:{ title: 'Evaluacion Cuantitativa' } },
          { path: 'evaluaciones/onjobtraining', name: 'accOnJobTrainingPage', component: require(page+'account/evaluaciones/onjobtraining.vue').default, meta:{ title: 'On job training' } },


          

          { path: 'politicas-y-reglamentos', name: 'accPoliticasPage', component: require(page+'account/politicas-reglamentos/index.vue').default, meta:{ title: 'Políticas y reglamentos' } },
          { path: 'politicas-y-reglamentos/:id', name: 'accPoliAvisoPage', component: require(page+'account/politicas-reglamentos/aviso.vue').default, meta:{ title: 'Políticas y reglamentos' } },
        ]
      },

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Grupo OZ", filter: (title)=>{ return title+" - Grupo OZ"; } }
);

// export {routes};
export default MyRouter;
